import React, { useEffect, useState } from 'react';
import { useCoverLetter } from '../../../context/CoverLetterContext';
import PlusIcon from '../../../assets/images/white-plus-icon.svg';
import TickIcon from '../../../assets/images/white-tick-small.svg';
import WpAPI from '../../../WpApi';
import LoadingIcon from '../../../images/spinner.svg';


const SkillsForm = ({ data, save }) => {
    const { job_details_provided, desired_position, skills_fetched_params, skills, skills_list_displayed, qa_steps_initiated } = data
    let [skillsList, setSkillsList] = useState([]);

    const skillSet = [
        "Collaboration",
        "Communication",
        "Critical Thinking",
        "Customer Service",
        "Decision-Making",
        "Delegation",
        "Innovation",
        "Interpersonal",
        "Leadership",
        "Management",
        "Motivation",
        "Observation",
        "Organization",
        "Planning",
        "Problem-Solving",
        "Team-Building",
        "Teamwork",
        "Time-Management"
    ]
    const inputChanged = () => (
        skills_fetched_params.desired_position != desired_position ||
        skills_fetched_params.job_details_provided != job_details_provided
    )
    useEffect(() => {
        if(qa_steps_initiated){ //In case it reloads, process only when object is initialised. this flag will make sure.
        //Either the first time or desired_position changed
            if (!skills_list_displayed.length || inputChanged()) {
                const dp = job_details_provided == false ? '': desired_position
                WpAPI.getJobSkills(dp).then(res => {
                    setSkillsList(res)
                    save({
                        skills_list_displayed: res,
                        skills_fetched_params: {
                            desired_position: dp  ,
                            job_details_provided: job_details_provided,
                            datetime: Date.now()
                        },
                        skills:[]
                    })
                    //set the fetched_params
                })
            } else if (skills_list_displayed.length) {
                setSkillsList(skills_list_displayed)
            }
        }
    }, [qa_steps_initiated]);

    return (<div className="screen-block">
        {/* //Duplicate screen start  */}
        <div className="skills-list">
            {
                skillsList.length ? skillsList.map((skill) => {
                    return (
                        <div
                            className={`skill${data.skills.indexOf(skill) != -1 ? " selected" : ''}`}
                            onClick={() => {
                                if (data.skills.indexOf(skill) !== -1) {
                                    let temp = data.skills
                                    let rem = temp.indexOf(skill);
                                    temp.splice(rem, 1);
                                    // setUserSkills(userSkills)
                                    save({ skills: [...temp] })

                                } else {

                                    data.skills.length < 3 && save({ skills: [...data.skills, skill] })
                                    // console.log(userSkills)
                                }
                            }}
                            key={`skill-${skill}`}
                        >
                            <span>
                                {skill}
                                <i className="skill-icon">
                                    {data.skills.indexOf(skill) != -1 ? <TickIcon /> : <PlusIcon />}
                                </i>
                            </span>
                        </div>
                    )
                }) : <LoadingIcon />
            }
        </div>
    </div>)
}

export default SkillsForm